import { render, staticRenderFns } from "./PlcTpl.vue?vue&type=template&id=5151e4fc&scoped=true"
import script from "./PlcTpl.vue?vue&type=script&lang=js"
export * from "./PlcTpl.vue?vue&type=script&lang=js"
import style0 from "./PlcTpl.vue?vue&type=style&index=0&id=5151e4fc&prod&scoped=true&lang=css"
import style1 from "./PlcTpl.vue?vue&type=style&index=1&id=5151e4fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5151e4fc",
  null
  
)

export default component.exports